import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

import { ITrackingProps } from "../../types";

export const productTileTrackingAdapter = (
  productTile: ILeanProductTile,
  showVerticalImagery: boolean
): ITrackingProps => {
  return {
    productToken: productTile.product?.token ?? undefined,
    brandToken: productTile.product?.brand_token ?? undefined,
    selectedProductOptionToken:
      productTile?.selected_product_option_token ?? undefined,
    isPromoted: productTile.product?.is_promoted ?? false,
    impressionId: productTile.product?.impression_id ?? undefined,
    promotedBy: productTile.product?.promoted_by ?? [],
    badgeList: productTile?.badge_list ?? undefined,
    bestImage: productTile?.best_image ?? undefined,
    images: productTile?.images ?? [],
    settingsToAssignOnView: productTile?.settings_to_assign_on_view ?? [],
    showVerticalImagery,
  };
};
